import {
  Action,
  ActionType,
  IConsentStatementResponse,
} from "models/consentStatement/getConsentStatement";
import createReducer from "redux/createReducer";

export interface ConsentStatementReducerType {
  loading: boolean;
  error?: string;
  consentStatementResponse?: IConsentStatementResponse;
}

const defaultState: ConsentStatementReducerType = {
  loading: false,
  error: undefined,
  consentStatementResponse: undefined,
};

export const consentStatementReducer =
  createReducer<ConsentStatementReducerType>(defaultState, {
    [ActionType.GET_CONSENT_STATEMENT](state: ConsentStatementReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_CONSENT_STATEMENT_ERROR](
      state: ConsentStatementReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        consentStatementResponse: undefined,
      };
    },

    [ActionType.GET_CONSENT_STATEMENT_SUCCESS](
      state: ConsentStatementReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        consentStatementResponse: action.payload,
      };
    },

    [ActionType.GET_CONSENT_STATEMENT_RESET](
      state: ConsentStatementReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        consentStatementResponse: undefined,
      };
    },
  });
